import React, { useState, useEffect } from 'react'
import { useTranslate } from 'react-polyglot'

import EE from 'emitter.js'
import { Modal, Button, ButtonGroup, Text } from 'components'

export default () => {
	const [isOpen, setIsOpen] = useState(false)
	const [data, setData] = useState({ url: null })

	const t = useTranslate()

	useEffect(() => {
		EE.on('showSlugChangedModal', ({ url }) => {
			setData({ url })
			setIsOpen(true)
		})

		return () => {
			EE.off('showSlugChangedModal')
		}
	}, [])

	return (
		<Modal
			visible={isOpen}
			closable={false}
			onClose={() => setIsOpen(false)}
			title={t('forms.changed_url_title')}
		>
			<Text>{t('forms.changed_url_text')}</Text>

			<ButtonGroup orientation="horizontal">
				<Button
					onClick={() => {
						window.location.href = data.url
					}}
					text={t('app_update_button')}
					size="small"
					layout="primary"
				/>
			</ButtonGroup>
		</Modal>
	)
}
